import moment from 'moment';

export const getNewTimeRange = (relativeTime) => {
    var selections = {};
    var endMoment = moment();
    selections.endDateTime = endMoment.format();
    var formatedEndDate = endMoment.format('l');
    var formattedEndTime = endMoment.format('hh:mm');
    var endAMPM = endMoment.format('A');
    var startMoment;
    switch (relativeTime) {
        case 'wtd':
            startMoment = endMoment.startOf('week');
            break;
        case 'mtd':
            startMoment = endMoment.startOf('month');
            break;
        case 'ytd':
            startMoment = endMoment.startOf('year');
            break;
        case '15m':
            startMoment = endMoment.subtract({ minutes: 15 });
            break;
        case '30m':
            startMoment = endMoment.subtract({ minutes: 30 });
            break;
        case '1H':
            startMoment = endMoment.subtract({ hours: 1 });
            break;
        case '1D':
            startMoment = endMoment.subtract({ days: 1 });
            break;
        case '7D':
            startMoment = endMoment.subtract({ days: 7 });
            break;
        case '1M':
            startMoment = endMoment.subtract({ months: 1 });
            break;
        case '3M':
            startMoment = endMoment.subtract({ months: 3 });
            break;
        case '6M':
            startMoment = endMoment.subtract({ months: 6 });
            break;
        case '1Y':
            startMoment = endMoment.subtract({ years: 1 });
            break;
        default:
            //console.log('default');
    }
    var formatedStartDate = startMoment.format('l');
    var formattedStartTime = startMoment.format('hh:mm');
    var startAMPM = startMoment.format('A');
    selections.startDateTime = startMoment.format();
    selections.startDate = formatedStartDate;
    selections.startTime = formattedStartTime;
    selections.startAMPM = startAMPM;
    selections.endDate = formatedEndDate;
    selections.endTime = formattedEndTime;
    selections.endAMPM = endAMPM;
    selections.timeRange = relativeTime;
    selections.timeRangeType = 'relative';
    return selections;
}